module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-Black.a5ca14c3.ttf";